// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js!./~/less-loader?sourceMap!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/clients/SelectContactsModal.vue
// module id = 409
// module chunks = 0